import { usePalette } from "@hq/command-palette";
import { IconButton, Sheet } from "@z/ui";
import { PanelLeft, PanelLeftClose, Search } from "lucide-react";
import { useState, useSyncExternalStore } from "react";
import { Sidebar } from "./Sidebar";
import { SIDEBAR_ID, useSidebarState } from "./useSidebarState";

const query = "(max-width: 1023px)";
function subscribe(onChange: () => void) {
  const media = window.matchMedia(query);
  media.addEventListener("change", onChange);
  return () => media.removeEventListener("change", onChange);
}
const isCompact = () => window.matchMedia(query).matches;
const serverSnapshot = () => false;

export function WorkspaceNavigation() {
  const compact = useSyncExternalStore(subscribe, isCompact, serverSnapshot);
  const [open, setOpen] = useState(false);
  const palette = usePalette();
  const { collapsed } = useSidebarState();
  if (!compact) return <Sidebar id={SIDEBAR_ID} collapsed={collapsed} />;
  return (
    <header className="flex h-12 shrink-0 items-center gap-2 border-b border-border bg-surface px-2">
      <button
        type="button"
        aria-label="Search workspace"
        className="flex h-10 min-w-0 flex-1 items-center gap-2 rounded-md bg-bg/60 px-2.5 text-sm text-fg-muted transition-colors hover:bg-surface-raised focus-ring"
        onClick={palette.open}
      >
        <Search aria-hidden="true" className="size-4 shrink-0" />
        <span className="truncate">Search anything</span>
      </button>
      <Sheet.Root open={open} onOpenChange={setOpen}>
        <Sheet.Trigger
          render={
            <IconButton label="Open navigation" className="size-10">
              <PanelLeft aria-hidden="true" strokeWidth={1.75} />
            </IconButton>
          }
        />
        <Sheet.Content
          side="left"
          showClose={false}
          className="w-72 max-w-[calc(100vw-2rem)] gap-0 p-0 pt-[env(safe-area-inset-top,0px)] pr-[env(safe-area-inset-right,0px)] pb-[env(safe-area-inset-bottom,0px)] pl-[env(safe-area-inset-left,0px)]"
        >
          <Sheet.Title className="sr-only">Navigation</Sheet.Title>
          <Sidebar className="h-auto w-full flex-1 border-r-0" onNavigate={() => setOpen(false)} />
          <Sheet.Close className="flex h-11 shrink-0 items-center gap-2 border-t border-border px-5 text-sm text-fg-muted transition-colors hover:bg-fg/6 hover:text-fg focus-ring">
            <PanelLeftClose aria-hidden="true" className="size-4" />
            Close navigation
          </Sheet.Close>
        </Sheet.Content>
      </Sheet.Root>
    </header>
  );
}
